import React from "react";
import {
  Box,
  MainButton,
  MainText,
  PressableOpacity,
} from "app/components/common";
import OnboardingWebTitle from "./OnboardingWebTitle";
import normalize from "app/utils/normalize";
import ArrowLeftSlider from "app/components/Icons/ArrowSlider/ArrowLeftSlider";
import theme from "app/Theme/Theme";
import { useNavigation } from "@react-navigation/native";

interface IProps {
  title: string;
  subTitle: string;
  body: React.ReactElement;
  firstTextRedirection?: string;
  secondTextRedirection?: string;
  testIDButton?: string;
  textButton: string;
  isButtonDisable: boolean;
  isButtonLoading: boolean;
  onPressButton: () => void;
  onPressRedirection?: () => void;
}

const OnboardingWebBody = ({
  title,
  subTitle,
  body,
  firstTextRedirection,
  secondTextRedirection,
  testIDButton,
  textButton,
  isButtonDisable,
  isButtonLoading,
  onPressButton,
  onPressRedirection,
}: IProps) => {
  const navigation = useNavigation();

  const onClickBack = () => {
    navigation.goBack();
  };

  return (
    <Box
      flex={1}
      flexDirection="column"
      paddingLeft="webXL"
      paddingTop={{ smallWeb: "webXM", web: "webL" }}
      paddingBottom={{ smallWeb: "webXM", web: "webXL" }}
    >
      <PressableOpacity
        onPress={onClickBack}
        style={{
          marginLeft: -normalize(12),
        }}
      >
        <ArrowLeftSlider
          color={theme.colors["neutral.900"]}
          width={normalize(40)}
          height={normalize(40)}
        />
      </PressableOpacity>
      <Box
        alignItems="flex-start"
        height="100%"
        flex={1}
        paddingTop={{ smallWeb: "l", web: "webXM" }}
      >
        <OnboardingWebTitle title={title} text={subTitle} />
        <Box width={normalize(344)} flex={1}>
          {body}
        </Box>
        <Box width={normalize(344)}>
          <MainButton
            testID={testIDButton}
            text={textButton}
            onPress={onPressButton}
            isDisabled={isButtonDisable}
            isLoading={isButtonLoading}
          />
          <Box marginTop="xs" alignItems="center">
            <PressableOpacity onPress={onPressRedirection}>
              <Box flexDirection="row" alignItems="center">
                <MainText variant="l4-medium" marginRight="xxs">
                  {firstTextRedirection}
                </MainText>
                <MainText variant="l4-medium" color="brand.500">
                  {secondTextRedirection}
                </MainText>
              </Box>
            </PressableOpacity>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default OnboardingWebBody;
